import Select, { SelectProps } from "@/shared/form/select";
import { useTranslations } from "use-intl";
import {
  FALSE,
  TRUE,
} from "@/shared/dynamic-attributes/ui/dynamic-attribute-field/dynamic-attribute-field-simple/dynamic-attribute-field-simple-boolean-select-values";
import { DynamicAttributeFieldSimpleMetaFragment } from "gql/graphql";

type Value = boolean | null | string;

export type BooleanSelectProps = Omit<SelectProps, "onChange" | "value"> & {
  onChange?: (value: Value) => void;
  value?: Value;
  meta: DynamicAttributeFieldSimpleMetaFragment;
};

export function BooleanSelect({
  onChange,
  value,
  meta,
  ...props
}: BooleanSelectProps) {
  const t = useTranslations("Common");

  return (
    <Select
      value={value}
      onChange={(value) => {
        onChange?.(value);
      }}
      options={[
        {
          label: t("Yes"),
          value: TRUE,
        },
        {
          label: t("No"),
          value: FALSE,
        },
        !meta.required
          ? {
              label: t("All"),
              value: null,
            }
          : null,
      ].filter((option) => option !== null)}
      {...props}
    />
  );
}
